import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'
import imageBanner from './img/banner.png'
import imageTable from './img/table.jpg'

export const ces556h201: ProductProps = {
  tag: ProductTag.ESS,
  category: ProductCategory.CommercialEnergyStorageSystems,
  pathName: 'ces556h201',
  banner: imageBanner,
  title: 'CES556H201',
  description:
    'This energy storage system adopts the design of 20ft high containerincluding 10\nbattery racks system, 1 DC combiner cabinet, 1 set of liquid cooling/heating unit, 1 set of fire\nsuppression and lighting system,etc.',
  features: [
    {
      type: 'card-list',
      content: [
        {
          icon: 'safety',
          title: 'Meets crane requirements',
          description: [
            'The container system nneets the basic requirements of crane installation, and provides users with bolt fixing method and 4grounding points that meet the electricity standard requirements.',
          ],
        },
        {
          icon: 'safety',
          title: 'Security features',
          description: [
            'This container system has good environmental adaptability with aanti-corrosion, fireproof, waterproof, dustproof (anti-sand), shockproof, ultraviolet-prooti-theft and other functions.',
          ],
        },
      ],
    },
  ],
  specImages: [imageTable],
}
